import type { AnyFieldApi } from '@tanstack/react-form'

interface FieldInfoProps {
  field: AnyFieldApi
}

export function FieldInfo({ field }: FieldInfoProps) {
  return (
    <>
      {field.state.meta.isTouched && !field.state.meta.isValid
        ? field.state.meta.errors.map((err) => (
            <p key={err.message} className="text-sm text-destructive">
              {err.message}
            </p>
          ))
        : null}
      {field.state.meta.isValidating ? (
        <p className="text-sm text-muted-foreground">Validating...</p>
      ) : null}
    </>
  )
}
